var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Bienvenido a la Página administrar")]),_c('p',[_vm._v("Contenido de la página administrar")]),_c('router-link',{attrs:{"to":"/pagina2"}},[_vm._v("Ir a la Página ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }